import React, { useState, useEffect } from "react";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import BUDGET_API from "../../../../../apis/budget.api";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import DEATH_API from "../../../../../apis/death.api";
import { Modal, Table } from "antd";
import {  Button, Dropdown, Menu, Select, Icon  } from "antd";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png"


import moment from "moment";

const HiddenRecurringTable = ({setAllTransactions,allTransactions, unhideRecurringTransaction}) => {

    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [recurringTransactions, setRecurringTransactions] = useState([]);
    const [cachedData, setCachedData] = useState({});
    const [loading, setLoading] = useState(false);
    const [detailsModal, setDetailsModal] = useState(false);
    const [selectedObject, setSelectedObject] = useState([]); 
    const [unifiedList, setUnifiedList] = useState([]);
console.log('ALLTT-----------',allTransactions)
    const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

    const sortedData =
      selectedObject &&
      selectedObject.length > 0 &&
      [...selectedObject].sort((a, b) => {
        if (sortConfig.key === "date") {
          return sortConfig.direction === "asc"
            ? new Date(a.date) - new Date(b.date)
            : new Date(b.date) - new Date(a.date);
        } else if (sortConfig.key === "amount") {
          return sortConfig.direction === "asc"
            ? a.amount - b.amount
            : b.amount - a.amount;
        }
        return 0;
      });

    // useEffect(() => {
    //   if(allTransactions){
    //     setRecurringTransactions(allTransactions)
    //   }
    // }, [allTransactions]);

    useEffect(() => {
        const fetchSystemRecurring = async (page) => {
          setLoading(true);
          try {
            const data = await BUDGET_API.fetchSystemRecurringTransactions(page);
            const systemData = data && data.data && data.data.transactions || [];
    
            // Map system recurring transactions
            // const mappedSystem = systemData.map((item) => {
            //   const rawDate = item.transaction && item.transaction.date || null;
            //   const isoDate = rawDate ? new Date(rawDate).toISOString() : null;
            //   return{
            //     id: item.recurringToken && item.recurringToken.id || null,
            //     itemName: item.recurringToken && item.recurringToken.token || "N/A",
            //     occurance: item.totalTransactions && item.totalTransactions || "N/A",
            //     bankName: item.transaction && item.transaction.account || "N/A",
            //     amount: item.transaction.amount ? item.transaction.amount : "N/A",
            //     accountType: item.transaction && item.transaction.accountType || "N/A",
            //     accountNumber: item.transaction && item.transaction.accountNumber || "N/A",
            //     frequency: item.recurringToken && item.recurringToken.frequency || "N/A",
            //     dueDate: isoDate,
            //     itemLogo: null,
            //     status: "Confirmed"
            //   }
            // });
    
            // Map prediction transactions (from props)
            const mappedPrediction = allTransactions.map((item) => {
              const rawDate = item.transaction && item.transaction.date || null;
              const isoDate = rawDate ? new Date(rawDate).toISOString() : null;
              return{
                id: item.id || null,
                itemName: item.itemName || "N/A",
                occurance: item.occurance || "N/A",
                bankName: item.bankName || "N/A",
                amount: item.amount ? item.amount : "N/A",
                accountType: item.accountType || "N/A",
                accountNumber: item.accountNumber || "N/A",
                frequency: item.frequency || "N/A",
                dueDate: item.date || null,
                itemLogo: item.itemLogo || null,
                status: item.frequency.toLowerCase() === "irregular" ? "Needs Review" : "Predicted",
              }
            });
    
            // Combine both
            setUnifiedList([...mappedPrediction]);
            console.log("unifiedList--------------------->>>>>",[ ...mappedPrediction])
          } catch (error) {
            console.error("Error fetching system recurring data:", error);
          }finally{
            setLoading(false)
          }
        };
    
        fetchSystemRecurring(currentPage);
      }, [allTransactions]);

      const getSortValue = (record) => {
        if (
          record.frequency &&
          record.frequency.toLowerCase() === "irregular"
        ) return Number.POSITIVE_INFINITY;
      
        if (!record.date) return Number.POSITIVE_INFINITY;
      
        const currentDate = new Date();
        const dueDate = new Date(record.date);
        let nextDueDate = new Date(dueDate);
      
        switch (record.frequency && record.frequency.toLowerCase()) {
          case "monthly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(currentDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate > nextDueDate) {
              nextDueDate.setMonth(nextDueDate.getMonth() + 1);
            }
            break;
      
          case "weekly":
            while (nextDueDate <= currentDate) {
              nextDueDate.setDate(nextDueDate.getDate() + 7);
            }
            break;
      
          case "yearly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(dueDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate >= nextDueDate) {
              nextDueDate.setFullYear(currentDate.getFullYear() + 1);
            }
            break;
      
          default:
            // Frequency unknown = expired
            return Number.NEGATIVE_INFINITY;
        }
      
        return nextDueDate.getTime(); // accurate for sorting
      };

      function calculateDueStatus(record) {
        // debugger
        const currentDate = new Date();
        let dueDate = new Date(record.dueDate);
      
        let nextDueDate = new Date(dueDate); // Start from the original due date
      
        switch (record.frequency) {
          case "Monthly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(currentDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate > nextDueDate) {
              nextDueDate.setMonth(currentDate.getMonth() + 1);
            }
            break;
      
          case "Weekly":
            while (nextDueDate <= currentDate) {
              nextDueDate.setDate(nextDueDate.getDate() + 7);
            }
            break;
      
          case "Yearly":
            nextDueDate.setFullYear(currentDate.getFullYear());
            nextDueDate.setMonth(dueDate.getMonth());
            nextDueDate.setDate(dueDate.getDate());
      
            if (currentDate >= nextDueDate) {
              nextDueDate.setFullYear(currentDate.getFullYear() + 1);
            }
            break;
      
          default:
            return "Expired";
        }
      
        if (dueDate.toDateString() === currentDate.toDateString()) {
          return "Today";
        } else if (dueDate < currentDate) {
          const timeDifference = nextDueDate.getTime() - currentDate.getTime();
          const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          return `In ${daysDifference} days`;
        } else {
          const timeDifference = dueDate.getTime() - currentDate.getTime();
          const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
          return `In ${daysDifference} days`;
        }
      }

      const getSelectedRecords = async(record) => {
        setDetailsModal(true);
        console.log("record.predictionTransactions", record);
        if (record.id) {
         try {
          setLoading(true);
          if(record.status !== "Confirmed"){
            let data = await BUDGET_API.fetchAllRelatedTransaction(record.id);
            if (data && data) {
              setSelectedObject(data);
            }
          }else{
            let data1 = await BUDGET_API.fetchRecurringAppliedTransaction(
              record.id,
              1,
              20
            );
            if (data1 && data1.data.transactions) {
              // setSelectedObject(data.data.transactions);
              const newData = data1.data.transactions.map(item => item.transaction)
              setSelectedObject((prevItems) => [
                ...prevItems,
                // ...data1.data.transactions,
                ...newData,
              ]);
          }
        }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
        }
      };

      const handleCancel = () => {
        setSelectedObject([]);
        setDetailsModal(false);
      };

      const renderSortIcon = (key) => {
        if (sortConfig.key !== key) return null; // No icon if the column is not sorted
    
        // Return both icons, with the appropriate one being active
        return (
          <>
            {sortConfig.direction === "asc" ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "white", fontSize: "8px" }}>▲</span>{" "}
                {/* Upward arrow */}
                <span style={{ color: "gray", fontSize: "8px" }}>▼</span>{" "}
                {/* Downward arrow (inactive) */}
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ color: "gray", fontSize: "8px" }}>▲</span>{" "}
                {/* Upward arrow (inactive) */}
                <span style={{ color: "white", fontSize: "8px" }}>▼</span>{" "}
                {/* Downward arrow */}
              </div>
            )}
          </>
        );
      };

      const handleSort = (key) => {
        setSortConfig((prevConfig) => ({
          key,
          direction:
            prevConfig.key === key && prevConfig.direction === "asc"
              ? "desc"
              : "asc",
        }));
      };
    
      const cols = [
        {
          title: "Item",
          dataIndex: "itemName",
          sorter: (a, b) => (a.itemName || a.token || "").localeCompare(b.itemName || b.token || ""),
          render: (fileName, record) => {
            return record.itemName || record.token ? (
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    cursor: "pointer",
                    alignItems: "center",
                  }}
                  onClick={() => {
                   getSelectedRecords(record);
                  }}
                >
                  <img
                    style={{ borderRadius: "50%" }}
                    height={34}
                    width={34}
                    src={record.itemLogo ? record.itemLogo : plaidIcon}
                  ></img>
                  <div>
                    <div>{record.itemName || record.token}</div>
                    <div
                      style={{
                        color:
                          record.frequency &&
                          record.frequency.toLowerCase() === "irregular"
                            ? "red"
                            : "#2a3da3",
                        fontStyle: record.frequency &&
                          record.frequency.toLowerCase() === "irregular" && "italic",
                        fontWeight: "bold",
                      }}
                    >
                      {record.frequency && record.frequency}
                    </div>
                    {record.frequency &&
                      record.frequency.toLowerCase() !== "irregular" && (
                        <div style={{ color: "#79797D", fontWeight: "lighter" }}>
                          {record.frequency.toLowerCase() === "monthly"
                            ? "1 Transaction"
                            : record.count && record.count + " " + "Transactions"}
                        </div>
                      )}
                  </div>
                </div>
              </React.Fragment>
            ) : (
              "N/A"
            );
          },
        },
        {
          title: "No. of Transactions",
          dataIndex: "occurance",
          sorter: (a, b) => {
            const occA = parseInt(a.occurance) || 0;
            const occB = parseInt(b.occurance) || 0;
            return occA - occB;
          },
          render: (fileName, record) => {
            return record.occurance ? <div>{record.occurance}</div> : "N/A";
          },
        },
        {
          title: "Bank",
          dataIndex: "bankName",
          sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
          render: (fileName, record) => {
            return record.bankName || record.accountName ? (
              <div>
                {record.accountVaired ? (
                  "Vaired"
                ) : (
                  <div>
                    <div>
                      {record.accountName
                        ? `${record.accountName}`
                        : record.bankName || ""}
                    </div>
                    {record.accountType && (
                      <span style={{ color: "black" }}>{record.accountType}</span>
                    )}
                  </div>
                )}
              </div>
            ) : record.paidUsing == "Cash" ? (
              "Cash"
            ) : (
              "N/A"
            );
          },
        },
        {
          title: "Amount",
          dataIndex: "amount",
          sorter: (a, b) => {
            const amountA = parseFloat(a.amount);
            const amountB = parseFloat(b.amount);
            // Toggle sorting order directly
            if (amountA < amountB) {
              return -1; // Sort in ascending order
            } else if (amountA > amountB) {
              return 1; // Sort in descending order
            } else {
              return 0; // Leave items unchanged if they are equal
            }
          },
          render: (fileName, record) =>{
            const val = typeof record.amount === "number"
            ? `$${record.amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : "N/A"
            return(
              <div
                style={{
                  width: "100%",
                  fontWeight: "bold",
                  // color: record < 0 ? "#00A27B" : "",
                  color: record.amount < 0 ? "black" : "#00A27B",
                }}
              >
                {record.amount
                  ? !isNaN(record.amount)
                    ? record.amountVaired
                      ? "Varied"
                      : `${
                          record.amount && record.amount < 0
                            ? "$" +
                              record.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "$" +
                              record.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        }`
                    : "N/A"
                  : "N/A"}
              </div>
            )
          }
            
        },
        {
          title: "Account",
          dataIndex: "accountNumber",
          sorter: (a, b) =>
            (a.accountNumber || "").localeCompare(b.accountNumber || ""),
          render: (fileName, record) => {
            return record.accountNumber ? (
              <div>
                {record.accountVaired ? (
                  "Vaired"
                ) : (
                  <div>{"****" + record.accountNumber}</div>
                )}
              </div>
            ) : (
              "N/A"
            );
          },
        },
        {
          title: "Due",
          dataIndex: "dueDate",
          // render: (date) =>
          //   date
          //     ? new Date(date).toLocaleDateString("en-US", {
          //         year: "numeric",
          //         month: "2-digit",
          //         day: "2-digit",
          //       })
          //     : "N/A",
          sorter: (a, b) => getSortValue(a) - getSortValue(b),
          sortDirections: ["ascend", "descend"],
          render: (fileName, record) => {
            if (
              record.frequency &&
              record.frequency.toLowerCase() === "irregular"
            ) {
              return "Varied";
            }
            // debugger
            if (record.dueDate) {
              const status = calculateDueStatus(record);

              if (status.toLowerCase() === "expired") {
                return <span style={{ color: "red" }}>{status}</span>;
              }

              return status;
            }

            return "N/A";
          }
        },
        {
          title: "Status",
          dataIndex: "status",
          render: (record) => {
            return (
              <div
                style={{
                  color:
                    record.frequency &&
                    record.frequency.toLowerCase() === "irregular"
                      ? "red"
                      : "#2a3da3",
                  fontStyle:
                    record.frequency &&
                    record.frequency.toLowerCase() === "irregular" &&
                    "italic",
                  fontWeight: "bold",
                }}>
                {record && record}
              </div>
            );
          }
            
        },
        {
                  title: "Actions",
                  dataIndex: "actions",
                  render: (fileName, record) => {
                    return (
                      <>
                        <Dropdown
                          trigger={["click"]}
                          overlay={
                            <Menu>
                               <Menu.Item>
                                <div
                                  onClick={() => {
                                    unhideRecurringTransaction(record.id,currentPage);
                                  //   // setShareModal(true);
                                  //   // setUpdateObject(data);
                                  }}
                                  >
                                  Un-Hide
                                </div>
                              </Menu.Item>
                              
                              
                            </Menu>
                          }>
                          <a
                            className="ant-dropdown-link"
                            style={{ padding: "0px 8px" }}
                            // onClick={(e) => e.preventDefault()}
                          >
                            <img
                              className="imgIcon"
                              src={menuIcon}
                              height={15}
                              width={4}
                              alt="icon"></img>
                          </a>
                        </Dropdown>
                      </>
                    );
                  },
                },
      ];

      
  return (
    <div>
      <div className="tableContainer">
        <Table
          columns={cols}
          dataSource={unifiedList && unifiedList}
          pagination={{
             total: totalPages * 10, // Assuming 10 items per page
            // current: currentPage,
            // onChange: (page) => {
            //   setCurrentPage(page);
            // },
            pageSize: 20, // Number of items per page
          }}
        />
      </div>
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Transaction Details</h3>
        <h3 className="modaltitle">{selectedObject.length} Transactions</h3>

        <div>
          <div
            className=""
            style={{ height: "18rem", maxHeight: "18rem", overflow: "auto" }}
            id="transactions-main"
          >
            {sortedData && sortedData.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th
                      onClick={() => handleSort("date")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Date {renderSortIcon("date")}
                    </th>
                    <th>Name</th>
                    <th>Category</th>
                    <th
                      onClick={() => handleSort("amount")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Amount {renderSortIcon("amount")}
                    </th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {sortedData &&
                    sortedData.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.date && data.date
                            ? moment(data.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td>
                          {data.itemName && data.itemName
                            ? data.itemName
                            : "N/A"}
                        </td>
                        <td>
                          {data &&
                          data.categoryFromPlaid
                            ? data.categoryFromPlaid
                            : "N/A"}
                        </td>
                        <td>
                          {" "}
                          ${" "}
                          {data && data.amount
                            ? `${data.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "0"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">No Transaction to Show</h3>
            )}
          </div>
        </div>
      <NewLoader isLoading={loading} />

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
      <NewLoader isLoading={loading} />
    </div>
  );
}

export default HiddenRecurringTable
